import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { LOGO } from "../lib/constants";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("hrh_token")) {
      api.get("/auth/me").then(() => navigate("/admin")).catch(() => localStorage.removeItem("hrh_token"));
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("hrh_token", data.access_token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] grid place-items-center px-6 purple-radial">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm border border-[var(--border)] bg-black/40 p-10">
        <img src={LOGO} alt="HRH" className="h-16 w-16 object-contain mx-auto mb-6" />
        <h1 className="font-serif text-2xl text-center mb-8 flex items-center justify-center gap-2"><Lock className="w-4 h-4 text-[var(--gold)]" /> Admin</h1>
        <input className="w-full bg-transparent border-b border-white/20 focus:border-[var(--gold)] py-3 mb-6 outline-none text-white placeholder:text-white/30" placeholder="Email" type="email" data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input className="w-full bg-transparent border-b border-white/20 focus:border-[var(--gold)] py-3 mb-8 outline-none text-white placeholder:text-white/30" placeholder="Password" type="password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button type="submit" disabled={loading} data-testid="admin-signin" className="btn-fill w-full border border-[var(--gold)] text-[var(--gold)] py-3 text-xs uppercase tracking-[0.2em] flex items-center justify-center transition-colors duration-300">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
        </button>
      </form>
    </div>
  );
}
